module.exports = __webpack_public_path__ + "static/Auswertung_Beteilligungsphase_II-5b60ed77523d2d15525600f2fc719f9c.pdf";